import apiFetch from '../apiFetch'

export default function (token, associatedCostId) {
  return apiFetch({ endPoint: `RecoverAssociatedCostType/${associatedCostId}`, method: 'PUT', associatedCostTypeId: null, token: token })
}
